import { getMedusaSearchParameters } from '@lib/services/medusa-search.service'

export const fetchSearchParameters = async (locale: string, set: any) => {
  set({ isLoadingSearchParameters: true, error: null })
  try {
    const response = await getMedusaSearchParameters(locale)
    set({ searchParameters: response, isLoadingSearchParameters: false })
  } catch (error) {
    set({
      error: error instanceof Error ? error.message : 'Unknown error',
      isLoadingSearchParameters: false,
    })
  }
}
